import { ReactNode, useEffect } from "react";

import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

interface DatadogProviderProps {
  children: ReactNode;
}

export const DatadogProvider = ({ children }: DatadogProviderProps) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
    const serviceName = process.env.NEXT_PUBLIC_DD_SERVICE_NAME;
    const applicationId = process.env.NEXT_PUBLIC_DD_APPLICATION_ID;

    if (!clientToken || !serviceName) {
      // eslint-disable-next-line no-console
      console.warn("Datadog client token or service name not provided. Logging disabled.");
      return;
    }

    // Initialize Datadog logs
    datadogLogs.init({
      clientToken,
      site: "datadoghq.com",
      service: serviceName,
      env: process.env.NEXT_PUBLIC_APP_ENV || process.env.NODE_ENV,
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
    });

    // Initialize Datadog RUM
    if (applicationId) {
      datadogRum.init({
        applicationId,
        clientToken,
        site: "datadoghq.com",
        service: serviceName,
        env: process.env.NEXT_PUBLIC_APP_ENV || process.env.NODE_ENV,
        version: process.env.NEXT_PUBLIC_APP_VERSION,
        sessionSampleRate: Number(process.env.NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE) || 5,
        sessionReplaySampleRate: Number(process.env.NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE) || 5,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      });

      datadogRum.startSessionReplayRecording();
    }
  }, []);

  return <>{children}</>;
};
